export const SOLICITUD_POST_ERROR = 'SOLICITUD_POST_ERROR';
export const POST_SOLICITUD_EXITOSO = 'POST_SOLICITUD_EXITOSO';
export const POST_LOADING_SOLICITUD = 'POST_LOADING_SOLICITUD';
export const CLEAN_GUARDAR_SOLICITUD = 'CLEAN_GUARDAR_SOLICITUD';